import Alert from './Alert';

const GlobalMarketWarning: IComponent = () => (
  <Alert
    severity="warning"
    title="Global market"
    link={{
      label: 'Configure markets',
      href: '/settings/store/commercial-segments/markets',
    }}
  >
    The global market is not supported in this view. Please select a market from
    the dropdown in the top right corner.
  </Alert>
);

export default GlobalMarketWarning;
